<template>
  <base-content :data="data"
    :index="index">
      <template #card-header>
        <partial-title
          :title="title"
          :link="link"
          :lineClamp="3"
        />
      </template>

      <template #card-body>
        <ul>
          <li class="t-sm t-overflow">
            <template v-if="data.total_cost && data.total_cost_currency">
              <span class="t-600">{{ { amount: data.total_cost, currency: data.total_cost_currency } | formatCurrency }}</span> from {{ data.funding_source.name }}
            </template>
            <template v-else>
              <span><br /></span>
            </template>
          </li>
          <matches v-if="!isEmpty(matches)" :matches="matches" />
        </ul>
      </template>

      <template #card-footer>
        <li v-if="dateString" class="row-content">
          <i class="fa fa-calendar row-content--side"></i>
          <span class="row-content--main">
            {{ dateString }}
          </span>
        </li>

        <partial-organisations v-if="!isEmpty(organisations)"
          :organisations="organisations"
          :highlights="highlightOrganisations"
          :highlightKey="'organisations.name'"
          :lineClamp="1">
        </partial-organisations>

      </template>
      <template #card-actions>
        <slot name="actions"></slot>
      </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/project'

import BaseContent from '@/components/search/results/BaseContent'
import Matches from '@/components/search/results/partials/Matches'
import PartialTitle from '@/components/search/results/partials/Title'
import PartialOrganisations from '@/components/search/results/partials/Organisations'

export default {
  name: 'projectResultBlock',
  mixins: [processing],
  components: {
    Matches,
    PartialTitle,
    PartialOrganisations,
    BaseContent
  }
}
</script>
